import { useEffect, useState } from 'react';

function fmtDateTime(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  return isNaN(d.getTime()) ? '—' : d.toLocaleString('es-MX', { hour12: false });
}

const STATUS_LABELS = {
  draft: 'Borrador',
  armed: 'Armado',
  active: 'Activo',
  completed: 'Completado',
  cancelled: 'Cancelado',
};

export default function Viajes({ authHeaders, devices }) {
  const [trips, setTrips] = useState([]);
  const [f, setF] = useState({ tractor: '', tractor_device_id: '', box: '', box_device_id: '', client_name: '', client_email: '', temp_min: '', temp_max: '' });

  async function load() {
    try {
      const res = await fetch('/api/trips', { headers: authHeaders() });
      if (res.ok) setTrips(await res.json());
    } catch (e) {}
  }

  useEffect(() => { load(); }, []);

  function set(key, v) { setF((p) => ({ ...p, [key]: v })); }

  async function createTrip() {
    try {
      const res = await fetch('/api/trips', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...authHeaders() },
        body: JSON.stringify({ ...f, temp_min: f.temp_min ? Number(f.temp_min) : null, temp_max: f.temp_max ? Number(f.temp_max) : null }),
      });
      const data = await res.json();
      if (!res.ok) { alert(data.error || 'Error'); return; }
      setF({ tractor: '', tractor_device_id: '', box: '', box_device_id: '', client_name: '', client_email: '', temp_min: '', temp_max: '' });
      await load();
    } catch (e) { alert('Error: ' + e.message); }
  }

  async function action(id, a) {
    try {
      await fetch(`/api/trips/${id}/${a}`, { method: 'POST', headers: authHeaders() });
      await load();
    } catch (e) { alert('Error: ' + e.message); }
  }

  function trackUrl(t) {
    return `${window.location.origin}/track/${t.token_guest}`;
  }

  return (
    <div className="manual">
      <section className="card">
        <h2>Nuevo viaje</h2>
        <div className="cmd-form">
          <input placeholder="Tractocamión (ej. Freightliner 01)" value={f.tractor} onChange={(e) => set('tractor', e.target.value)} />
          <select value={f.tractor_device_id} onChange={(e) => set('tractor_device_id', e.target.value)}>
            <option value="">— Dispositivo del tractor —</option>
            {devices.map((d) => <option key={d.id} value={d.uniqueid}>{d.uniqueid || d.name}</option>)}
          </select>
          <input placeholder="Caja (ej. Caja 02)" value={f.box} onChange={(e) => set('box', e.target.value)} />
          <input placeholder="Device ID de la caja (sensores)" value={f.box_device_id} onChange={(e) => set('box_device_id', e.target.value)} />
        </div>
        <div className="cmd-form">
          <input placeholder="Cliente" value={f.client_name} onChange={(e) => set('client_name', e.target.value)} />
          <input placeholder="Email del cliente" value={f.client_email} onChange={(e) => set('client_email', e.target.value)} />
          <input placeholder="Temp. mín (°C)" value={f.temp_min} onChange={(e) => set('temp_min', e.target.value)} />
          <input placeholder="Temp. máx (°C)" value={f.temp_max} onChange={(e) => set('temp_max', e.target.value)} />
          <button onClick={createTrip}>Crear viaje</button>
        </div>
      </section>

      <section className="card panel">
        <h2>Viajes ({trips.length})</h2>
        <table>
          <thead>
            <tr><th>Tracto</th><th>Caja</th><th>Cliente</th><th>Temp</th><th>Estado</th><th>Inicio</th><th>Acciones</th></tr>
          </thead>
          <tbody>
            {trips.length === 0 && <tr><td colSpan={7} className="empty">Sin viajes</td></tr>}
            {trips.map((t) => (
              <tr key={t.id}>
                <td>{t.tractor || '—'}</td>
                <td>{t.box || '—'}</td>
                <td>{t.client_name || '—'}</td>
                <td>{t.temp_min != null || t.temp_max != null ? `${t.temp_min ?? '—'}–${t.temp_max ?? '—'}°C` : '—'}</td>
                <td>
                  <span className={`status status-${t.status === 'active' || t.status === 'completed' ? 'ok' : t.status === 'cancelled' ? 'error' : 'pending'}`}>
                    {STATUS_LABELS[t.status] || t.status}
                  </span>
                </td>
                <td className="dim">{fmtDateTime(t.starts_at)}</td>
                <td>
                  {t.status === 'draft' && <button className="mini" onClick={() => action(t.id, 'start')}>Iniciar</button>}
                  {t.status === 'active' && (
                    <>
                      <button className="mini" onClick={() => window.prompt('URL de monitoreo (Ctrl+C para copiar):', trackUrl(t))}>URL cliente</button>
                      <button className="mini" onClick={() => action(t.id, 'complete')}>Completar</button>
                    </>
                  )}
                  {(t.status === 'draft' || t.status === 'active') && <button className="mini del" onClick={() => action(t.id, 'cancel')}>Cancelar</button>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>
    </div>
  );
}
